module.exports = __webpack_public_path__ + "static/media/debit-down.72384fd5.png";